import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import * as messageConstants from '../../../shared/messages';
import RedirectUriRow from "./RedirectUriRow";

class RedirectUri extends Component {
  static propTypes = {
    oidcRedirectUris: PropTypes.arrayOf(
      PropTypes.shape({
        redirectUri: PropTypes.string,
        redirectUriType: PropTypes.number,
      })
    ),
    handleUpdateOidcRedirectUri: PropTypes.func,
  };

  handleUpdateEvent = (value) => {
    this.props.handleUpdateOidcRedirectUri(value);
  };

  render() {
    return (
      <div className="pt-31">
        <p className="sba-subtitle">
          {messageConstants.OIDC_URI_TITLE}
        </p>
        &nbsp;
        <div className="add-edit-subtitle">
          {messageConstants.OIDC_URI_SUBTITLE}
        </div>
        <RedirectUriRow
          onOidcRedirectUrisUpdate={this.handleUpdateEvent}
          oidcRedirectUri={
            this.props.oidcRedirectUris.length > 0
              ? this.props.oidcRedirectUris[0]
              : { redirectUri: '' }
          }/>
      </div>
    );
  }
}

export default RedirectUri;
